import { useEffect } from 'react'
import { useUserStore } from '~/entities/user'
import { PINNED_FILTERS_STORAGE_KEY } from '../config'
import type { PinnableDocumentFilterKey } from './types'
import { usePinnedFiltersSelectors } from './use-pinned-filters-store'

export const useInitializeDefaultPinnedFilters = () => {
  const isOnshore = useUserStore((state) => state.isOnshore)
  const { setPinnedFilters } = usePinnedFiltersSelectors()

  useEffect(() => {
    const storedValue = localStorage.getItem(PINNED_FILTERS_STORAGE_KEY)
    if (storedValue !== null) return

    const defaultPinnedFilters = isOnshore
      ? ['status', 'phase', 'visibility', 'date']
      : ['status', 'phase', 'date']

    setPinnedFilters(defaultPinnedFilters as PinnableDocumentFilterKey[])
  }, [isOnshore, setPinnedFilters])
}
